import _classCallCheck from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins_home/workspace/tingle.0974c021-198f-4724-af33-81ecc1444bfe/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { randomString } from './random_string';
/**
 * Create a generator instance.
 */

export var SequenceIdGenerator =
/*#__PURE__*/
function () {
  function SequenceIdGenerator() {
    _classCallCheck(this, SequenceIdGenerator);

    this._sequenceId = randomString.generateBase64(16);
    this._sequenceNumbers = {};
  }
  /**
   * Create a generator instance.
   *
   * @return A sequence_id and sequence_number generator
   * instance.
   */


  _createClass(SequenceIdGenerator, [{
    key: "reset",

    /**
     * Reset the state and generate a new sequence_id.
     */
    value: function reset() {
      this._sequenceId = randomString.generateBase64(16);
      this._sequenceNumbers = {};
    }
    /**
     * Get the latest sequence_id.
     *
     * @return The sequence_id used to identify events.
     */

  }, {
    key: "getSequenceId",
    value: function getSequenceId() {
      return this._sequenceId;
    }
    /**
     * Generate the next sequence_number to identify events.
     *
     * @param eventName - The name of the event to generate a sequence_number
     * for.
     * @return Incremental number starting from 1.
     */

  }, {
    key: "nextSequenceNumber",
    value: function nextSequenceNumber(eventName) {
      if (!this._sequenceNumbers[eventName]) {
        this._sequenceNumbers[eventName] = 0;
      }

      return ++this._sequenceNumbers[eventName];
    }
  }, {
    key: "nextSequenceNumberNoIncrement",
    value: function nextSequenceNumberNoIncrement(eventName) {
      if (!this._sequenceNumbers[eventName]) {
        this._sequenceNumbers[eventName] = 0;
      }

      return this._sequenceNumbers[eventName] + 1;
    }
    /**
     * Get all sequence_numbers.
     *
     * @return All sequence numbers.
     */

  }, {
    key: "getAllSequenceNumberCounters",
    value: function getAllSequenceNumberCounters() {
      return this._sequenceNumbers;
    }
  }], [{
    key: "create",
    value: function create() {
      return new SequenceIdGenerator();
    }
  }]);

  return SequenceIdGenerator;
}();